export enum TimeFrameEnum {
    FirstNinetyDays = 'FirstNinetyDays',
    FourToSixMonths = 'FourToSixMonths',
    SevenToNineMonths = 'SevenToNineMonths',
    TenToTwelveMonths = 'TenToTwelveMonths',
    FirstSetofActionsOutsideof12Months = 'FirstSetofActionsOutsideof12Months',
}
